import { useEffect } from 'react'
import { SplashScreen } from '../components/SplashScreen'
import { TopBar } from '../components/TopBar'
import { Sidebar } from '../components/Sidebar'
import { OfficeAppsSidebar } from '../components/OfficeAppsSidebar'
import { FeaturedCards } from '../components/FeaturedCards'
import { RecentFiles } from '../components/RecentFiles'
import styles from '../App.module.css'

const IndexPage = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      const hash = window.location.pathname.slice(1)
      const target = hash && hash !== '/' ? `/login?${hash}` : '/login'
      window.location.href = target
    }, 4000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className={styles.app}>
      <SplashScreen duration={10000} onComplete={() => {}} />
      <TopBar />
      <div className={styles.body}>
        <OfficeAppsSidebar />
        <Sidebar />
        <main className={styles.main}>
          <FeaturedCards />
          <RecentFiles />
        </main>
      </div>
    </div>
  )
}

export default IndexPage
